import { editorEnum } from 'src/model/editor/editorEnum'

export const templateDataCollection = [
  {
    name: 'Default',
    id: 0,
    path: 'sections',
    primaryColor: '#015FFB',
    font: 'Inter',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png',
    value: [
      {
        type: editorEnum.headerType,

        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/Default.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:;background-image:;background-position:;background-size:;" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:;background-image:;background-position:;background-size:;" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>
        <div class="simple-box-wrapper" style="background-color:;background-image:;background-position:;background-size:;" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.&nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-1.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:;background-image:;background-position:;background-size:;" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(217,99%,49%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:;background-image:;background-position:;background-size:;" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(217,99%,49%);" id="header-title">Courses</span> </h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Vibrant',
    id: 5,
    path: 'sections',
    font: 'Manrope',
    primaryColor: '#000000',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/vibrant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 2,
          alignment: 'left',
          priceTagActive: true,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/vibrant.jpg',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#dffd6e;background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.&nbsp;</span></p>
            <p style="text-align:center;"><span>Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet-2.jpg">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2 id="author-title"><span>Meet Your Instructor</span></h2>
            <p id="author-description"><span>Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience. </span></p>
            
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-3.png" alt="">
              </div>
            </div>
          </div>
        </div>

      <div class="simple-box-wrapper" style="background-color:#ffd9d9;background-position:'';background-size:'';" background-image="" background-color="#ffd9d9" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;" id="video-section-title"><span>Watch &amp; Learn</span></h2>
            <p style="text-align:center;" id="video-section-description"><span>Get a glimpse of what's inside! Watch this short video to explore key insights and understand how this program can benefit you.</span></p>
            <div class="video-wrapper">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 0%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">Step by Step</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$99,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(132, 25%, 20%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
      `,
        },
      },
    ],
  },
  {
    name: 'Dynamic',
    id: 11,
    path: 'sections',
    primaryColor: '#116CFF',
    font: 'Saira',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/dynamic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 3,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/dynamic.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(0, 0%, 17%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span color:hsl(0, 0%, 17%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>


      <div class="simple-box-wrapper" style="background-color:#116cff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#116cff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#116cff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#116cff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">$200/Month</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">6 Meet/Session</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">Video &amp; Quiz</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2 style="color:hsl(0, 0%, 17%);">Courses </h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
              
      `,
        },
      },
    ],
  },
  {
    name: 'Classic',
    id: 1,
    path: 'sections',
    primaryColor: '#001B47',
    font: 'Questrial',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/classic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/classic.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `  <div class="simple-box-wrapper" style="background-color:;">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);">Discover, Learn, and Grow</span></h2>
                <p>Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
        </div>
    </div>
    
    <!-- Meet Your Instructor Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <div class="img-wrapper">
                    <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
                </div>
            </div>
            <div class="column">
                <h2><span style="color:hsl(0, 0%, 100%);">Meet Your Instructor</span></h2>
                <p><span style="color:hsl(0, 0%, 100%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
            </div>
        </div>
    </div>
    
    
    
    
    <!-- Earn Your Credential Section -->
    <div class="simple-box-wrapper">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);">Earn Your Credential</span></h2>
                <p>Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.&nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column">
                <div class="img-wrapper">
                    <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
                </div>
            </div>
        </div>
    </div>
    
    
    <!-- Program Details Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);">Program Details</span></h2>
                <p style="text-align:center;"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
            </div>
        </div>
    </div>
    
    
    <!-- Program Stats Section -->
    <div class="simple-box-wrapper" background-color="#001b47" style="background-color:#001b47;">
        <div class="simple-box">
            <div class="column">
                <div class="card-wrapper">
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="level">Beginner level</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="duration">3 weeks</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="price">$10,00</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2> <span style="color:hsl(217, 100%, 14%);">Courses</span> </h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>
    
    `,
        },
      },
    ],
  },
  {
    name: 'Discover',
    id: 6,
    path: 'sections',
    primaryColor: '#0077B6',
    font: 'Nunito Sans',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/discover.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 2,
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/discover.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>🌍 </span><span style="color:hsl(201, 100%, 36%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(201, 100%, 36%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
           
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>✨</span><span style="color:hsl(201, 100%, 36%);" id="author-title"> Who Are We?</span></h2>
            <p style="text-align:center;" id="author-description">I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/discover-2.png" alt="">
            </div>
          </div>
        </div>
      </div>

      

      
<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-1.png" alt="">
              </div>
            </div>
          </div>
        </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="program_details-title">📖 Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Ages 18-35</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:youtube" iconname="hugeicons:youtube" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">Video content</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">12+ Destinations</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$5.95</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
      


      

     `,
        },
      },
    ],
  },
  {
    name: 'Minimal',
    id: 2,
    primaryColor: '#7346F1',
    path: 'sections',
    font: 'Lato',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/minimal.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/minimal.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#f5f7fe;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f5f7fe" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(256, 86%, 61%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#f5f7fe;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f5f7fe" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration" id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>   

        

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-1.png" alt="">
              </div>
            </div>
          </div>
        </div>  
        <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(256, 86%, 61%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>     
`,
        },
      },
    ],
  },
  {
    name: 'Organic',
    id: 13,
    path: 'sections',
    font: 'Georama',
    primaryColor: '#696D2C',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/organic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 3,
          alignment: 'left',
          priceTagActive: true,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/organic.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(64, 42%, 30%);"><strong>Welcome to your learning journey!</strong> Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>



    <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#696D2C;" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>

      

    
      <div class="simple-box-wrapper" style="background-color:#979c7e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#979c7e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#979c7e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#979c7e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(64, 42%, 30%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Elegant',
    id: 3,
    path: 'sections',
    primaryColor: '#947100',
    font: 'Barlow',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/elegant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/elegant.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(46, 100%, 29%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
          </div>
        </div>
      </div>

    

     <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#957300;" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">Free</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(46, 100%, 29%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>   `,
        },
      },
    ],
  },
  {
    name: 'Ascent',
    id: 12,
    path: 'sections',
    primaryColor: '#131313',
    font: 'Inter',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/ascent.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 3,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/ascent.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#222424;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#292a2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(50, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(0, 0%, 100%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(0, 0%, 7%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>


     <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#131313;" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 7%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 7%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Courses </h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
`,
        },
      },
    ],
  },
  {
    name: 'Horizon',
    id: 4,
    path: 'sections',
    primaryColor: '#273F2B',
    font: 'DM Sans',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/horizon.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/horizon.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#f2f5eb;background-position:'';background-size:'';" background-image="" background-color="#f2f5eb" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(132, 25%, 20%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f5eb;background-position:'';background-size:'';" background-image="" background-color="#f2f5eb" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p id="introduction-description"><span style="color:hsl(132, 25%, 20%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(132, 25%, 20%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(132, 25%, 20%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(132, 25%, 20%);" id="header-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>
`,
        },
      },
    ],
  },

  {
    name: 'Grow',
    id: 7,
    path: 'sections',
    primaryColor: '#015FFB',
    font: 'Sora',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/grow.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 1,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/grow.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg);background-position:top-center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="top-center" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><h1 style="text-align:center;">&nbsp;</h1><h1 style="text-align:center;"><span style="color:hsl(0,0%,0%);"><span id="introduction-title">Discover, Learn, and Grow</span></span></h1><p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey!&nbsp;</span></p><p style="text-align:center;"><span>Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p><p style="text-align:center;">&nbsp;</p></div></div></div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(240, 22%, 15%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(240, 22%, 15%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
            
          </div>
        </div>
      </div>
      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>
      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 0%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Courses </h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>

      `,
        },
      },
    ],
  },
  {
    name: 'Podcast',
    id: 8,
    path: 'sections',
    primaryColor: '#FF6B00',
    font: 'Inter',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/podcast.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 2,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/podcast.jpg',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(222, 36%, 11%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="author-title">🎙 About Me – Meet Your Mentor</span></h2>
            <p id="author-description"><span style="color:hsl(222, 36%, 11%);">Hi, I'm a podcast producer and host of the award-winning show Voices Unfiltered. When I started podcasting five years ago, I was just like you—unsure of my niche, nervous about my voice, and overwhelmed by all the technical aspects.</span></p>
            <p><span style="color:hsl(222, 36%, 11%);">Fast forward to today, and my podcast has reached thousands of listeners, secured sponsorships, and built a thriving community. Through this collection, I want to help you find your voice, just like I did!</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/podcast-about.png" alt="">
            </div>
          </div>
        </div>
      </div>


      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(25, 100%, 50%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(222, 36%, 11%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Courses </h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
     `,
        },
      },
    ],
  },
  {
    name: 'Divine',
    id: 9,
    path: 'sections',
    primaryColor: '#c3a169 ',
    font: 'Lato',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/divine.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 2,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/divine.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="introduction-title">Embrace Wisdom, Find Your Path</span></h2>
            <p id="introduction-description"><span>Growth begins with curiosity and a willingness to explore new perspectives. Whether you're seeking personal transformation, professional development, or a deeper understanding of the world around you, this collection is designed to guide you every step of the way.</span></p>
            <p><span>Through insightful lessons, practical strategies, and timeless wisdom, you'll gain the clarity and confidence to navigate your journey with purpose and fulfillment.</span></p>
          </div>
        </div>
      </div>


     <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#C4A26A;" id="certificate-title">Earn Your Sacred Recognition</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-2.png" alt="">
              </div>
            </div>
          </div>
        </div>

      <div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-quite.png);background-position:center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-quite.png" background-color="" background-type="image" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color="">
      <div class="simple-box">
          <blockquote id="wisdom-quote">
            <p><span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color:hsl(0, 0%, 100%);">&nbsp;"The path to understanding begins with curiosity. Let your heart and mind explore beyond the ordinary."</span></p>
            <p><span style="color:hsl(0, 0%, 100%);">Learn from enlightened guides who share knowledge rooted in experience and deeper awareness.</span></p>
          </blockquote>
        </div>
      </div>
<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:hsl(37, 43%, 59%);" id="header-title">Courses/span> </h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>
      
`,
        },
      },
    ],
  },
  {
    name: 'Playful',
    id: 10,
    path: 'sections',
    primaryColor: '#708800',
    font: 'Barlow',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/playful.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 3,
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.</span></p>
              <p style="text-align:center;"><span style="color:hsl(0, 0%, 17%);">Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#d9e59e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#d9e59e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 17%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#d9e59e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#d9e59e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;" id="author-title"><span>Meet Your Instructor</span></h2>
              <p style="text-align:center;" id="author-description"><span>Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful-img.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#2C2C2C;" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-3.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;" id="potential-title"><span style="color:hsl(0, 0%, 17%);">Unlock Your Potential</span></h2>
              <p id="potential-description"><span>Explore a world of knowledge designed to help you grow, adapt, and succeed. Whether you're looking to build new skills or deepen your understanding, this program provides the tools and support you need.</span></p>
            </div>
          </div>
        </div>
        <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2>Courses </h2>
                    <div class="dynamic-list" data-type="courseList1"  data-grid="4">
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
  {
    name: 'Momentum',
    id: 14,
    primaryColor: '#0453F1',
    path: 'sections',
    font: 'Space Grotesk',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/momentum.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          type: 2,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/momentum.png',
          description:
            'Explore our comprehensive collection of courses designed to help you achieve your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="intro-subtitle">Dive in, Explore more</span></h2>
              <p id="introduction-description"><span><strong>Welcome to your learning journey!</strong> This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow.&nbsp;</span></p>
              <p><span>Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable. Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>


        <div class="simple-box-wrapper" style="background-color:#f4f6f8;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f4f6f8" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(220, 97%, 48%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#f4f6f8;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f4f6f8" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval" id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#0453F1;" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.  &nbsp;<br><br>Show others your commitment to learning and growth.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/collection-certificate-1.png" alt="">
              </div>
            </div>
          </div>
        </div>
        
        <div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                  <h2><span style="color:#0453F1;" id="certificate-title">Courses </span></h2>
                    <div class="dynamic-list" data-type="courseList2" data-template="" data-grid="1">
                    </div>
                  </div>
                </div>
              </div>`,
        },
      },
    ],
  },
]
